var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlert = function SvgAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7 -8)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 20,
    r: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1 22.3L16.6 9c-.3-.5-.9-.5-1.2 0L7.9 22.3c-.3.4.1 1 .6 1h15.1c.5 0 .8-.5.5-1zM9.6 22L16 10.7 22.4 22H9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3 15.4V18c0 .4.3.7.7.7s.7-.3.7-.7v-2.6c0-.4-.3-.7-.7-.7s-.7.3-.7.7z"
  }))));
};
export { SvgAlert as ReactComponent };
export default "data:image/svg+xml,export default 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxOCAxNiI+CiAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNyAtOCkiPgogICAgICAgIDxjaXJjbGUgY3g9IjE2IiBjeT0iMjAiIHI9Ii43Ii8+CiAgICAgICAgPHBhdGggZD0iTTI0LjEgMjIuM0wxNi42IDljLS4zLS41LS45LS41LTEuMiAwTDcuOSAyMi4zYy0uMy40LjEgMSAuNiAxaDE1LjFjLjUgMCAuOC0uNS41LTF6TTkuNiAyMkwxNiAxMC43IDIyLjQgMjJIOS42eiIvPgogICAgICAgIDxwYXRoIGQ9Ik0xNS4zIDE1LjRWMThjMCAuNC4zLjcuNy43cy43LS4zLjctLjd2LTIuNmMwLS40LS4zLS43LS43LS43cy0uNy4zLS43Ljd6Ii8+CiAgICA8L2c+Cjwvc3ZnPg=='";